const RASTER_IMAGE_EXT = new Set([
  "jpg",
  "jpeg",
  "png",
  "gif",
  "bmp",
  "webp",
]);

export function isRasterImageFile(file) {
  if (!file?.name) return false;
  const ext = file.name.split(".").pop()?.toLowerCase() ?? "";
  return RASTER_IMAGE_EXT.has(ext);
}

export function isRasterImageFileName(name) {
  if (!name) return false;
  const ext = String(name).split(".").pop()?.toLowerCase() ?? "";
  return RASTER_IMAGE_EXT.has(ext);
}
